import { render, staticRenderFns } from "./Industrial_Products.vue?vue&type=template&id=1ecfea78&scoped=true"
import script from "./Industrial_Products.vue?vue&type=script&lang=js"
export * from "./Industrial_Products.vue?vue&type=script&lang=js"
import style0 from "./Industrial_Products.vue?vue&type=style&index=0&id=1ecfea78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecfea78",
  null
  
)

export default component.exports